import { cn } from "@/utils";
import type { ComponentPropsWithoutRef } from "react";
import type { CanvasToolbarOrientation } from "./CanvasToolbarShell";
import { canvasToolbarGroupVariants } from "./canvasToolbarStyles";

interface CanvasToolbarGroupProps extends ComponentPropsWithoutRef<"div"> {
  orientation?: CanvasToolbarOrientation;
}

export function CanvasToolbarGroup({
  orientation = "horizontal",
  className,
  children,
  ...rest
}: CanvasToolbarGroupProps) {
  return (
    <div
      className={cn(canvasToolbarGroupVariants({ orientation }), className)}
      {...rest}
    >
      {children}
    </div>
  );
}
